export default {
  /**
   * 装置が異常値かどうかを判定する
   * @param {String} status ステータス
   * @returns {Boolean} 異常値かどうか undefinedのものは false を返す
   */
  isAbnormalMachinery(status) {
    if(typeof status === "undefined" || status == null){
      return false
    }
    return (status.trim().includes("*") || status.trim().includes("S"))
  },

  /**
   * ステータスがイベントかどうか判定する
   * @param {String} status ステータス
   * @returns {Boolean} イベントかどうか undefinedのものは false を返す
   */
  isEventStatus(status) {
    if(typeof status === "undefined" || status == null){
      return false
    }
    return status.trim().includes("E")
  },
};
